import React from 'react';
import { createIconComp } from './createIconComp';

const icon = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="32" height="32" rx="16" fill="currentColor"/>
<g clip-path="url(#clip0_43047_14998)">
<path d="M22.1632 8.45097L9.18345 12.4432C8.28025 12.7211 8.11598 13.9286 8.91225 14.4376L12.7472 16.8891C12.9466 17.0166 13.1816 17.0769 13.4177 17.0612C13.6539 17.0456 13.8788 16.9548 14.0597 16.8022L18.8461 12.7632C19.1056 12.5443 19.4557 12.8942 19.2368 13.1539L15.1981 17.9411C15.0455 18.1219 14.9548 18.3469 14.9392 18.583C14.9236 18.8191 14.9839 19.054 15.1115 19.2534L17.5624 23.0878C18.0712 23.8838 19.2789 23.7195 19.5568 22.8166L23.549 9.8371C23.8106 8.98617 23.0139 8.18937 22.1632 8.45097Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_43047_14998">
<rect width="16" height="16" fill="white" transform="translate(8 8)"/>
</clipPath>
</defs>
</svg>
`;


export const SendIcon = createIconComp({ icon });
